import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserTagModel} from "../../models/user-tag.model";
import {FormControl} from "@angular/forms";
import {SpotifyTagsService} from "../../services/spotify-tags-service";
import {AddAlbumsToTagModel} from "../../models/add-albums-to-tag.model";
import {LoadingService} from "../../services/loading.service";

@Component({
  selector: 'app-add-albums',
  templateUrl: './add-albums.component.html',
  styleUrls: ['./add-albums.component.css']
})
export class AddAlbumsComponent implements OnInit {

  albums: AddAlbumsToTagModel[];
  albumsFiltered: AddAlbumsToTagModel[];
  @Input() tagToFilterOn: UserTagModel;
  @Output() addAlbumsEvent = new EventEmitter<any>();
  albumFilter = new FormControl('');
  loading$ = this.loadingService.loading$;

  constructor(private spotifyTagsService: SpotifyTagsService, private loadingService: LoadingService) {}

  ngOnInit() {
    this.spotifyTagsService.getAlbumsByTag(this.tagToFilterOn).subscribe(response => {
      this.albums = response;
      this.albumsFiltered = response;
      this.albumFilter.valueChanges.subscribe(value => {
        if (!value) {
          this.albumsFiltered = this.albums;
        } else {
          this.albumsFiltered = this.albums.filter(album => album.name.toLowerCase().includes(value.toLowerCase()) ||
              album.artist.toLowerCase().includes(value.toLowerCase()));
        }
      });
    });
  }

  selectTag(album: AddAlbumsToTagModel) {
    album.hasTag = !album.hasTag;
  }

  submit() {
    this.spotifyTagsService.addAlbumsToTag(this.tagToFilterOn, this.albums).subscribe(() => {
      this.addAlbumsEvent.emit();
    });
  }

  cancel() {
    this.addAlbumsEvent.emit();
  }

}
